import React, { useContext } from "react";
import AuthContext from "../firebase/auth-context/provider";
import StackdriverErrorReporter from "stackdriver-errors-js";
function Stackdriver(_ref) {
    let { children } = _ref;
    const { user } = useContext(AuthContext)[0];
    const errorHandler = new StackdriverErrorReporter();
    errorHandler.start({
        key: "AIzaSyA9NYRpYozVuYXaJiBFnYxaz80c2ZEQvI4",
        projectId: "makroskop-b14f3",
        context: {
            user
        }
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
}
export default Stackdriver;
